export default function themeScripts() {
  // Prevent the redirect when href is #
  (function () {
    var anchorTagsElements = document.querySelectorAll('a[href="#"]');

    anchorTagsElements.forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
      });
    });
  })();

  (function () {
    // If store is opened in a mobile webview apply customisations - hide navigation
    var queryParams = window.location.search;
    var urlParams = new URLSearchParams(queryParams);
    var mobile_shop = urlParams.get('mobile_shop');

    // Updates checkout with possible UTMs coming from mobile app webviews on Android/iOS
    var UTMSource = urlParams.get('utm_source');
    var UTMMedium = urlParams.get('utm_medium');
    var UTMId = urlParams.get('utm_id');
    var trackingUrlParams = new URLSearchParams();

    if (UTMSource) {
      trackingUrlParams.set('utm_source', UTMSource);
    }

    if (UTMMedium) {
      trackingUrlParams.set('utm_medium', UTMMedium);
    }

    if (UTMId) {
      trackingUrlParams.set('utm_id', UTMId);
    }

    if (mobile_shop === 'true') {
      document.body.classList.add('mobile-shop');
      var checkoutButton = document.querySelector('.go-cart__checkout-btn');
      if (checkoutButton) {
        checkoutButton.classList.add('mobile-shop');
        var checkoutButtonLink = checkoutButton.getAttribute('href');
        checkoutButton.setAttribute('href', `${checkoutButtonLink}?mobile_shop=true&${trackingUrlParams.toString()}`);
      }
      // updates cart attribute field in order to get campaign from order status page
      var attributeField = document.querySelector('input[name="attributes[campaign]"]');
      if (attributeField) {
        attributeField.value = UTMId;
      }
    }
  })();
}
